import { apiClient } from "./apiConfig";

export const createPaymentIntent = async (publicToken) => {
  const res = await apiClient.post(
    `/payments/create-payment-intent`,
    { public_token: publicToken },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data?.data || null;
};

export const confirmPaymentRecord = async (publicToken, paymentIntentId) => {
  const res = await apiClient.post(
    `/payments/insert`,
    {
      public_token: publicToken,
      payment_intent_id: paymentIntentId,
    },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data?.data || null;
};
